/* Piece Verse header behavior: mega menu (click/hover/Esc/outside) and mobile drawer (focus trap, Esc, overlay close). */
if (!customElements.get('bk-header')) {
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])';

  class BkHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('.bk-drawer');
      this.panel = this.querySelector('.bk-drawer__panel');
      this.openBtn = this.querySelector('[data-bk-drawer-open]');
      this.hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
      this.desktopQuery = window.matchMedia('(min-width: 990px)');

      this.openBtn?.addEventListener('click', () => this.openDrawer());
      this.querySelectorAll('[data-bk-drawer-close]').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));
      this.drawer?.addEventListener('keydown', (e) => this.onDrawerKey(e));
      this.desktopQuery.addEventListener('change', () => this.closeDrawer(false));

      this.megas = Array.from(this.querySelectorAll('[data-bk-mega]'));
      this.megas.forEach((wrap) => this.bindMega(wrap));
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this.closeAllMegas();
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeAllMegas(true);
      });
    }

    bindMega(wrap) {
      const btn = wrap.querySelector('button');
      const panel = wrap.querySelector('.bk-mega');
      btn.addEventListener('click', (e) => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        // Mouse click on a hover-capable device keeps the hover-opened panel open; keyboard (detail 0) and touch toggle.
        if (expanded && e.detail > 0 && this.hoverQuery.matches) return;
        this.toggleMega(wrap, !expanded);
      });
      wrap.addEventListener('mouseenter', () => this.hoverQuery.matches && this.toggleMega(wrap, true));
      wrap.addEventListener('mouseleave', () => this.hoverQuery.matches && this.toggleMega(wrap, false));
      wrap.addEventListener('focusout', (e) => {
        if (!wrap.contains(e.relatedTarget)) this.toggleMega(wrap, false);
      });
      this.panels = this.panels || new Map();
      this.panels.set(wrap, { btn, panel });
    }

    toggleMega(wrap, open) {
      const { btn, panel } = this.panels.get(wrap);
      if (open) this.closeAllMegas(false, wrap);
      btn.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    }

    closeAllMegas(restoreFocus = false, except = null) {
      (this.megas || []).forEach((wrap) => {
        if (wrap === except) return;
        const { btn, panel } = this.panels.get(wrap);
        const wasOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        if (wasOpen && restoreFocus) btn.focus();
      });
    }

    openDrawer() {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      this.openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      this.panel.focus();
    }

    closeDrawer(restoreFocus = true) {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      if (restoreFocus) (this.lastFocus || this.openBtn).focus();
    }

    onDrawerKey(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.closeDrawer();
        return;
      }
      if (e.key !== 'Tab') return;
      const items = Array.from(this.panel.querySelectorAll(FOCUSABLE));
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('bk-header', BkHeader);
}
